export function emailValidation(message: string) {
  return (email: string) => {
    // This just checks if the email actually exists, in case it is not required
    if (!email) return
    if (email.match(/\S+@\S+\.\S+/)) return
    return message
  }
}

// The normal required doesn't use trimming, see: https://github.com/react-hook-form/react-hook-form/issues/1650
export function requiredWithTrimValidation(message: string) {
  return (value: string) => {
    if (value?.trim()) return
    return message
  }
}

export function requiredArray(message: string) {
  return (value: unknown) => {
    if (!Array.isArray(value)) return message
    if (value.length === 0) return message
  }
}

// The normal required doesn't use trimming, see: https://github.com/react-hook-form/react-hook-form/issues/1650
export function requiredNumber(message: string) {
  return (number: string) => {
    const num = parseInt(number)

    if (isNaN(num)) return message
    if (num == null) return message
    return
  }
}

export function urlValidation(message: string) {
  return (url: string) => {
    // This just checks if the url actually exists, in case it is not required
    if (!url) return
    if (isValidURL(url)) return
    return message
  }
}

function isValidURL(string: string) {
  try {
    new URL(string)
    return true
  } catch {
    // If string doesn't have protocol, try adding one
    try {
      new URL('http://' + string)
      return true
    } catch {
      return false
    }
  }
}
